// extracted by mini-css-extract-plugin
module.exports =  {"banner":"_93444fe79c--banner--JozvA","image":"_93444fe79c--image--uPYxM","text":"_93444fe79c--text--OSN6e"};